import { render, staticRenderFns } from "./Loginphone2.vue?vue&type=template&id=4bf18bbd&scoped=true&"
import script from "./Loginphone2.vue?vue&type=script&lang=js&"
export * from "./Loginphone2.vue?vue&type=script&lang=js&"
import style0 from "./Loginphone2.vue?vue&type=style&index=0&id=4bf18bbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf18bbd",
  null
  
)

export default component.exports